import { IconButton, OdinIconSize } from '@myosh/odin-components';
import { memo, useCallback } from 'react';
import { useAppDispatch } from '@/redux/hooks';
import { addDraftRow } from '@/redux/slices/table/slice';

interface AddRowButtonProps {
  label?: string;
  rowCount?: number;
}

const AddRowButton = ({ label, rowCount }: AddRowButtonProps) => {
  const dispatch = useAppDispatch();

  const handleAddRow = useCallback(() => {
    dispatch(
      addDraftRow({
        data: {
          id: crypto.randomUUID(),
          isFirst: true,
          stepNumber: 1,
          taskActivity: '',
          description: '',
          controls: [],
          initialRiskRating: 1,
          residualRiskRating: 1,
        },
        rowIndex: rowCount ?? 0,
      })
    );
  }, [dispatch, rowCount]);

  return (
    <div className="my-2 flex justify-center">
      {label && <span className="mr-2">{label}</span>}
      <IconButton
        onClick={handleAddRow}
        icon="CirclePlus"
        iconSize={OdinIconSize.Small}
        iconClassName="cursor-pointer rounded-sm hover:bg-primary-5"
      />
    </div>
  );
};

export default memo(AddRowButton);
